import React, { FunctionComponent, useEffect, useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import dxpDataLayerInitializationHandler from '../../../../common/utilities/dxpDataLayerInitializationHandler';
import RouterExtensionContext from '../react/RouterExtensionContext';
import { ROUTES } from '../constants/routes';
import SummaryContainer from '../../summary';
import ColoursContainer from '../../colours';
import AccessoriesContainer from '../../accessories';
import CatalogContainer from '../../catalog';
import usePlatformConfig from '../react/usePlatformConfig';
import dxpPriceDisplay from '../../common/utils/dxpDataLayerPriceDisplay';
import useWidgetContext from '../react/useWidgetContext';
import { DxpDataLayerEventNames } from '../../../../common/utilities/customDatalayerInterface';
import dxpDigitalDataAssignment from '../../../../common/utilities/dxpDigitalDataAssignment';

const AltSpcWidgetRouter: FunctionComponent = () => {
  const [currentPath, setCurrentPath] = useState<string | null>(null);
  const {
    platformConfig: { dxpDataLayer, priceDisplay },
  } = usePlatformConfig();
  dxpDataLayerInitializationHandler(dxpDataLayer);
  const { configuration } = useWidgetContext();

  useEffect(() => {
    dxpPriceDisplay.set(configuration.dimensions, priceDisplay);
  }, [dxpDataLayer, configuration, priceDisplay]);

  useEffect(() => {
    // TODO update in XPD-28799
    dxpDigitalDataAssignment({
      eventName: DxpDataLayerEventNames.CONFIGURATOR_ENTRY,
      pageTitle: document.title,
    });
  }, [currentPath]);

  return (
    <RouterExtensionContext.Provider value={{ currentPath, setCurrentPath }}>
      <Switch>
        <Route exact path={ROUTES.MODELS} component={CatalogContainer} />
        <Route exact path={ROUTES.COLOURS} component={ColoursContainer} />
        <Route exact path={ROUTES.ACCESSORIES} component={AccessoriesContainer} />
        <Route exact path={ROUTES.SUMMARY} component={SummaryContainer} />
        <Redirect from={ROUTES.INDEX} to={ROUTES.MODELS} />
      </Switch>
    </RouterExtensionContext.Provider>
  );
};

export default AltSpcWidgetRouter;
